import React, { useState } from 'react';
import Timer from '../../common/Timer';
const PercentageCalculator = ({ percentage }) => {

  const [value1, setValue1] = useState(percentage);
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const [showTimer, setShowTimer] = useState(false);
  const handleCalculate = () => {
    setShowTimer(true);
    if (!value1 || !value2) {
      setError('يرجى ادخال القيمتين بشكل صحيح');
      setResult('');
      setExplanation('');
      return;
    }
    const percentage = parseFloat(value1);
    const ofValue = parseFloat(value2);
    const calculatedResult = (percentage / 100) * ofValue;
    setResult(calculatedResult.toFixed(2));
    setExplanation(
      `${value1}% من ${value2} = (${value1}/100) * ${value2} = ${percentage / 100
      } * ${ofValue} = ${calculatedResult.toFixed(2)}`
    );
    setError('');
  };
  return (
    <div dir="rtl">
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="number"
          placeholder={value1}
          value={value1}
          onChange={(e) => setValue1(e.target.value)}
          className="form-control ml-2"
          style={{ height: '50px' }}
        />
       {'\u00A0'} <span>%</span>{'\u00A0'}
        {'\u00A0'}<span> من </span>{'\u00A0'}
        <input
          type="number"
          placeholder="القيمة"
          value={value2}
          onChange={(e) => setValue2(e.target.value)}
          className="form-control ml-2"
          style={{height: '50px' , marginLeft: '5px', marginRight: '5px' }}
        />

        <button
          className="btn btn-primary  btn-lg" style={{ backgroundColor: '#43314A', borderColor: '#43314A', marginRight: '3px',fontSize: '20px' }}
          onClick={handleCalculate}
          disabled={showTimer}
        >
          {showTimer ? (
            <Timer
              duration={3}
              onTimeout={() => setShowTimer(false)}
            />
          ) : (
            "  احسب"
          )}
        </button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>خطأ: {error}</p>
        ) : (
          <>
            {result !== '' && !showTimer && (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  النتيجة: {value1}% من {value2} = {result}
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-white'>
                    خطوات الحل: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default PercentageCalculator;